import './index.css';
import './global.scss';
import './styles/main.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import App from './App';
import store from './store/configureStore';
import { ThemeProvider } from './theme';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
	<Provider store={store()}>
		<ThemeProvider>
			<ToastContainer
				limit={1}
				className='bt_toast'
			/>
			<HelmetProvider>
				<App />
			</HelmetProvider>
		</ThemeProvider>
	</Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
